import { Component, OnInit, ViewChild } from '@angular/core';
import { MotivationFullDetails } from '../model/all-motivations.interface';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AbstractMotivationsService } from 'src/app/moov-common/services/motivation/motivations.abstract.service';
import { MatSidenav } from '@angular/material/sidenav';
  
@Component({
  selector: 'app-motivations-view',
  templateUrl: './motivations-view.component.html',
  styleUrls: ['./motivations-view.component.scss']
})
export class MotivationsViewComponent extends BaseComponent implements OnInit {
  motivationsList: MotivationFullDetails[] = [];
  imageRootFolder = 'assets/motivations/';
  selectedMotivationId: string = "";
  @ViewChild("moovSideNav") sideNavRef: MatSidenav;

    constructor(private readonly motivationsService: AbstractMotivationsService) {
        super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.getAllMotivations();
  }

  getAllMotivations(): void{
  this.motivationsService.getAllMotivations().subscribe((allMotivations:MotivationFullDetails[]) => {
    // console.log(`allMotivationsDetails=${JSON.stringify(allMotivations)}`);
    if (allMotivations != undefined && allMotivations.length > 0){
      // sort active moovs list
      allMotivations = allMotivations.sort((am1, am2) => {
        if (am1.name > am2.name){
          return 1;
        }
        else if (am1.name < am2.name){
          return -1;
        }
        else{
          return 0;
        }

      });
    }
    this.motivationsList = allMotivations;
  })
}

  openMotivation(motivationId: string): void{
    this.selectedMotivationId = motivationId;
    this.sideNavRef.open();   
  }

  closeMotivationSideNav(): void{
    this.sideNavRef.close();
  }

  onSidebarClose(): void{
    this.selectedMotivationId = "";
  }
}